import React from 'react';

import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import assetTypes from './asset-types';

const AssetTypeSelector = ({
  selectedType,
  selectedSubtype,
  onTypeChange,
  onSubtypeChange,
  disabled,
}) => {
  const selectedAssetType = assetTypes.find((type) => type.value === selectedType);

  return (
    <div>
      <FormControl fullWidth disabled={disabled}>
        <InputLabel>Asset Type</InputLabel>
        <Select
          label="Asset Type"
          value={selectedType}
          onChange={(e) => onTypeChange(e.target.value)}
        >
          {assetTypes.map((type) => (
            <MenuItem key={type.value} value={type.value}>
              {type.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {selectedAssetType && (
        <FormControl fullWidth style={{ marginTop: '16px' }} disabled={disabled}>
          <InputLabel>Asset Subtype</InputLabel>
          <Select
            label="Asset Subtype"
            value={selectedSubtype}
            onChange={(e) => onSubtypeChange(e.target.value)}
          >
            {selectedAssetType.subtypes.map((subtype) => (
              <MenuItem key={subtype.value} value={subtype.value}>
                {subtype.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </div>
  );
};

export default AssetTypeSelector;
